/**
 * @generated SignedSource<<3982a1b9621c6433269479816aec13b0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedFeaturedModuleContent_viewer$data = {
  readonly onSaleVerticals: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"HpSharedFeaturedModuleItem_onSaleVertical">;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedFeaturedModuleCarousel_viewer">;
  readonly " $fragmentType": "HpSharedFeaturedModuleContent_viewer";
};
export type HpSharedFeaturedModuleContent_viewer$key = {
  readonly " $data"?: HpSharedFeaturedModuleContent_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedFeaturedModuleContent_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedFeaturedModuleContent_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedFeaturedModuleCarousel_viewer"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OnSaleVertical",
      "kind": "LinkedField",
      "name": "onSaleVerticals",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpSharedFeaturedModuleItem_onSaleVertical"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "1349d3fe31853658b2af840b564aca9b";

export default node;
